import { render } from "./DeviceStatusIcon.vue?vue&type=template&id=36a88038"
import script from "./DeviceStatusIcon.vue?vue&type=script&lang=js"
export * from "./DeviceStatusIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__